// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// WARNING - Values under "firebase" and value of "googleApiKey" needs to be replaced from your own accounts
// If left as is, it firbase and google map related functionality will not work on LIVE instance.
export const environment = {
  production: false,
  ////PROJECT
  // firebase: {
  //   apiKey: "AIzaSyB7qeEfZR4W-quBtNuNVyCUPDZc_srbmj0",
  //   authDomain: "dev-corpcrs.firebaseapp.com",
  //   projectId: "dev-corpcrs",
  //   storageBucket: "dev-corpcrs.appspot.com",
  //   messagingSenderId: "670014343205",
  //   appId: "1:670014343205:web:c045eb8f17c0ea8f5ad7cc",
  //   measurementId: "G-FTKVDJE960"
  // },
  cashFree: {
    // corpCRS
    url: 'https://sandbox.cashfree.com/pg/links',
    baseURL: "https://sandbox.cashfree.com/pg/orders",
    'x-client-id': '137262985dc6f60df8c89d6a5a262731', // from UI
    'x-client-secret': '71909436af48eba30ae3098d14d8c3f110e63b52', // from UI
  },
  firebase: {
    apiKey: 'AIzaSyAg7cJzo2sMh-5xQ_2MWLSC-XcgayMf8pQ',
    authDomain: 'corp-crs.firebaseapp.com',
    projectId: 'corp-crs',
    storageBucket: 'corp-crs.appspot.com',
    messagingSenderId: '546442608726',
    appId: '1:546442608726:web:8889a76537f20c51bcfbf7',
    measurementId: 'G-DJJ3DNJW8X',
  },
  googleApiKey: 'AIzaSyAIIYOxA7qeetFz6TuR1Qewc0Rrjhzx7ZU',

  baseUrl: 'http://localhost:4200/',
  // baseUrl: 'http://corpsub.ginims.com/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
